<template>
	<section class="itv-vacancies-list">
		<div class="itv-vacancies-list__count">
			{{ getCountOutput }}
		</div>
		<template v-if="list && list.length > 0">
			<ul class="itv-vacancies-list__list">
				<li v-for="(item, i) in list" :key="i" class="itv-vacancies-list__item">
					<card :content="item" />
				</li>
			</ul>
			<primary-button
				v-if="pages[0] < pages[1]"
				class="itv-vacancies-list__show-more"
				:content="showMore"
				@click-event="$emit('showMore')"
			>
				<template #icon-left>
					<div class="itv-vacancies-list__icon">
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M19 1.99976C19.5523 1.99976 20 2.44748 20 2.99976L20 6.38423C20 6.93652 19.5523 7.38423 19 7.38423H15.5C14.9477 7.38423 14.5 6.93651 14.5 6.38423C14.5 5.83194 14.9477 5.38423 15.5 5.38423H16.4995C15.2172 4.51025 13.6685 4.00009 12 4.00009C7.58172 4.00009 4 7.58181 4 12.0001C4 12.5524 3.55228 13.0001 3 13.0001C2.44772 13.0001 2 12.5524 2 12.0001C2 6.47724 6.47715 2.00009 12 2.00009C14.2511 2.00009 16.3291 2.74464 18 3.99952L18 2.99975C18 2.44746 18.4478 1.99975 19 1.99976ZM21 11.0001C21.5523 11.0001 22 11.4478 22 12.0001C22 17.5229 17.5228 22.0001 12 22.0001C9.77403 22.0001 7.71708 21.272 6.05575 20.0423L6.05573 21.0001C6.05572 21.5524 5.608 22.0001 5.05571 22.0001C4.50343 22.0001 4.05572 21.5524 4.05573 21.0001L4.05579 17.7685C4.05579 17.5033 4.16117 17.2489 4.34873 17.0614C4.53629 16.8738 4.79067 16.7685 5.05591 16.7685L8.30339 16.7689C8.85568 16.769 9.30334 17.2168 9.30327 17.769C9.3032 18.3213 8.85543 18.769 8.30315 18.7689L7.73346 18.7688C8.96845 19.5491 10.4312 20.0001 12 20.0001C16.4183 20.0001 20 16.4184 20 12.0001C20 11.4478 20.4477 11.0001 21 11.0001Z"
								fill="#252628"
							/>
						</svg>
					</div>
				</template>
			</primary-button>
		</template>
		<div v-else class="itv-vacancies-list__empty">
			По вашему запросу не найдено вакансий. Попробуйте снова, изменив параметры
			поиска
		</div>
	</section>
</template>

<script>
import declineWordOfNum from '@/js/modules/decline-word-of-num.js'

import Card from './Card'
import PrimaryButton from '../ui/PrimaryButton'

export default {
	name: 'VacanciesList',
	components: {
		Card,
		PrimaryButton,
	},
	props: {
		count: {
			type: Number,
			default: 0,
		},
		list: {
			type: Array,
			default: () => {},
		},
		pages: {
			type: Array,
			default: () => {},
		},
	},
	data() {
		return {
			showMore: {
				btnColorType: 'noBorder',
				text: 'Показать еще',
			},
		}
	},
	computed: {
		getCountOutput() {
			return `${this.count} ${declineWordOfNum(this.count, [
				'вакансия',
				'вакансии',
				'вакансий',
			])}`
		},
	},
}
</script>
